export const extractFromPixel = (value: string) =>
  Number(value?.split('px')[0]);

export const extractLineHeightPixel = (value: string) =>
  value?.split(' !default')[0];
